export default "__VITE_ASSET__GK20WAFk__"